module.exports = __webpack_public_path__ + "static/media/testimonial_5.d11598c5.jpg";